<div>
	<div class="ibox-title" style="height: fit-content">
		<h5>{{ Title }}</h5>
	</div>

	<div class="ibox-content">
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Week
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				Month
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 2,
					'btn-warning': OptionID == 2
				}"
				(click)="SelectOption(2)"
			>
				Year
			</button>
		</div>

		<div class="StatGrid">
			<label>Visitor Count:</label>
			<p>{{ VisitorCount }}</p>

			<label>Check Point Count:</label>
			<p>{{ CheckPointCount }}</p>

			<label>Denied Entry Count:</label>
			<p>{{ DeniedEntryCount }}</p>
		</div>
	</div>
</div>
